<template>
    <modal id="register-modal">
        <template slot="title">Create Account</template>
        <template slot="body">
            <form action="#" method="post">
                <field-input placeholder="Full Name" v-model="form.name" :autofocues="true" :required="true"></field-input>
                <field-input type="email" placeholder="Email" v-model="form.email" :required="true"></field-input>
                <field-phone placeholder="Phone" v-model="form.phone" :required="true"></field-phone>
                <field-input type="password" placeholder="Password" v-model="form.password" :required="true"></field-input>
                <field-input type="password" placeholder="Confirm password" v-model="form.password_confirmation" :required="true"></field-input>
                <field-select v-model="form.heard_about_us" name="heard_about_us" placeholder="How did you hear about us?" :required="true">
                    <option v-for="item in heard_about_us_options" :value="item" v-text="item"></option>
                </field-select>
            </form>
        </template>
        <template slot="footer">
            <submit-button :form="form" @click="submit()" class="btn-primary" :with-icon="false" processing-text="Creating Account...">Register</submit-button>
        </template>
    </modal>
</template>
<script>
    export default {

      data() {
        return {
          form: new Form({
            name: '',
            email: '',
            phone: '',
            password: '',
            password_confirmation: '',
            heard_about_us: '',
          }),
          heard_about_us_options: [
            'ABC',
            'ATT/ATE',
            'Employer/Coworker',
            'Friend/Family ',
            'Social Media',
            'Other',
          ]
        }
      },

      mounted() {
        window.addEventListener('keyup', (e) => {
          if (e.keyCode == 13 && this.isModalOpen('register-modal') && this.listenKeys) {
            this.submit();
          }
        })
      },

      methods: {
        submit() {
          this.form.post(`/register`).then(response => {
            this.refreshPage();
          }).catch(errors => {
            Alert.error(errors.first())
          })
        }
      }
    }
</script>